var map = {
	"./Accelerated.svg": 3420,
	"./Agile.svg": 393,
	"./Airborne.svg": 3909,
	"./Alight.svg": 6576,
	"./Anguished.svg": 5785,
	"./Bleeding.svg": 1911,
	"./Blinded.svg": 2335,
	"./Break.svg": 4312,
	"./Burned.svg": 7699,
	"./Calm.svg": 146,
	"./Charging.svg": 1470,
	"./Concentrating.svg": 3784,
	"./Courageous.svg": 9332,
	"./Dazed.svg": 3503,
	"./Disarm.svg": 7909,
	"./Engaged.svg": 2666,
	"./Enraged.svg": 1055,
	"./Entangled.svg": 2789,
	"./Exposed.svg": 8369,
	"./Fatigue.svg": 2298,
	"./Flying.svg": 2682,
	"./Frightened.svg": 9061,
	"./Frozen.svg": 2225,
	"./Grabbed.svg": 7330,
	"./Guarding.svg": 4126,
	"./Hobbled.svg": 1267,
	"./Hungry.svg": 1964,
	"./Immobilized.svg": 1392,
	"./Impaired.svg": 5270,
	"./Impaled.svg": 927,
	"./Joyful.svg": 9072,
	"./Major Wound.svg": 6627,
	"./Marked.svg": 8491,
	"./Minor Wound.svg": 7687,
	"./Moderate Wound.svg": 6313,
	"./Poised.svg": 7235,
	"./Poisoned.svg": 1208,
	"./Prone.svg": 4015,
	"./Pull.svg": 8186,
	"./Push.svg": 1351,
	"./Reeling.svg": 7413,
	"./Restrained.svg": 1132,
	"./Ridden.svg": 6493,
	"./Sealed.svg": 9419,
	"./Shatter.svg": 3882,
	"./Shocked.svg": 6520,
	"./Shred.svg": 3647,
	"./Shrouded.svg": 5171,
	"./Skipped.svg": 4373,
	"./Slide.svg": 1202,
	"./Slowed.svg": 9875,
	"./Soaked.svg": 310,
	"./Stress.svg": 479,
	"./Stunned.svg": 9364,
	"./Suffocating.svg": 4130,
	"./Suppressed.svg": 7253,
	"./Taunted.svg": 5262,
	"./Thirsty.svg": 4848,
	"./Tough.svg": 9516,
	"./Vulnerable.svg": 7135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;